'use client';

import dynamic from 'next/dynamic';

import { SafeImage } from '@/ui';
import { validateImage } from '@lib';
import { clsx } from 'clsx';
import { useMediaQuery } from 'usehooks-ts';

import { imageMetaConverter } from '@/lib/server';

import { BannerProps } from '.';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });
const SimpleParallax = dynamic(() => import('simple-parallax-js'), { ssr: false });

export function ClientBackground({
  parallaxSpeed,
  image,
  video,
  increaseNavigationContrast,
}: {
  parallaxSpeed: number;
  image: BannerProps['image'];
  video: BannerProps['video'];
  increaseNavigationContrast: boolean;
}) {
  // const { parallaxStyle, ref } = useParallax<HTMLDivElement>(parallaxSpeed);
  const mobile = useMediaQuery('(max-width: 640px)');

  return (
    <div className="absolute flex w-full items-center" style={{ height: `${(parallaxSpeed || 1) * 100}%` }}>
      {(video?.mobilePlayer?.videoUrl || video?.desktopPlayer?.videoUrl) && (
        <ReactPlayer
          muted
          playsInline
          loop
          playing={
            mobile
              ? video.mobilePlayer?.autoplay || video.desktopPlayer?.autoplay
              : video.desktopPlayer?.autoplay || video.mobilePlayer?.autoplay
          }
          controls={
            mobile
              ? video.mobilePlayer?.controls || video.desktopPlayer?.controls
              : video.desktopPlayer?.controls || video.mobilePlayer?.controls
          }
          src={
            mobile
              ? video.mobilePlayer?.videoUrl || video.desktopPlayer?.videoUrl
              : video.desktopPlayer?.videoUrl || video.mobilePlayer?.videoUrl
          }
          height={'100%'}
          width={'100%'}
          style={{
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 5,
          }}
        />
      )}

      {increaseNavigationContrast && (
        <div className="absolute inset-x-0 top-0 z-10 -m-8 h-48 bg-gradient-to-b from-black/75 blur-xl" />
      )}

      <SimpleParallax
        key={imageMetaConverter(image.desktop)?.src}
        orientation={'down'}
        scale={parallaxSpeed || 1}
        overflow
      >
        {validateImage(image.desktop) && (
          <SafeImage
            src={image.desktop}
            priority
            fill
            sizes={'100vw'}
            className={clsx('overflow-visible object-cover', {
              'hidden sm:flex': image.mobile,
            })}
          />
        )}
      </SimpleParallax>

      <SimpleParallax
        key={`${imageMetaConverter(image.mobile)?.src}-mobile`}
        orientation={'down'}
        scale={parallaxSpeed || 1}
        overflow
      >
        {validateImage(image.mobile) && (
          <SafeImage
            src={image.mobile}
            fill
            priority
            sizes={'100vw'}
            className={clsx('overflow-visible object-cover', {
              'flex sm:hidden': image.desktop,
            })}
          />
        )}
      </SimpleParallax>
    </div>
  );
}
